import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { format } from "date-fns";

import { useServer } from "../../server/ServerContext";
import { PortalAxiosError } from "../../types";
import { UserPointsResponse } from "./types";
import { userKeys } from "./utils";

export const useUserPoints = <TData extends {} = UserPointsResponse>(
  options?: UseQueryOptions<UserPointsResponse, PortalAxiosError, TData>
) => {
  const server = useServer();

  return useQuery<UserPointsResponse, PortalAxiosError, TData>(
    userKeys.points,
    () =>
      server.get("user/points", {
        params: {
          timezone: format(new Date(), "xxx"),
        },
      }),
    {
      staleTime: 1 * 60 * 1000,
      ...options,
    }
  );
};

export default useUserPoints;
